import styled, { css } from 'styled-components'

export const Wrapper = styled.header`
  position: relative;
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 24px;
    height: 52px;
    min-height: 52px;
    width: 100%;
    z-index: ${theme.layers.base};
    background-color: white;
    border-bottom: 1px solid #c4c4c4;
  `}
`

export const LogoWrapper = styled.div`
  cursor: pointer;
  height: 24px;
  position: absolute;
  left: 50%;
  top: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    height: 35px;
    width: auto;
  }

  transform: translate(-50%, -50%);
`

export const HamburguerIconWrapper = styled.div`
  cursor: pointer;
  width: 24px;
  height: 20px;
`
